import type { ClassNames } from 'react-day-picker';

export const CALENDAR_BASE: Partial<ClassNames> = {
  months: 'flex w-[304px] flex-col sm:flex-row space-y-4 sm:space-x-4 sm:space-y-0',
  month: 'w-[304px] space-y-4',
  caption: 'flex justify-center pt-1 relative items-center',
  caption_label: 'w-40 text-center text-sm font-medium',
  nav: 'space-x-1 flex items-center',
  nav_button_previous: 'absolute left-1',
  nav_button_next: 'absolute right-1',
  table: 'w-full border-collapse space-y-1',
  head_row: 'grid grid-cols-7',
  head_cell: 'text-muted-foreground place-self-center rounded-md w-8 font-normal text-[0.8rem]',
  row: 'my-[4px] grid w-full grid-cols-7',
  day_range_start: 'day-range-start',
  day_range_end: 'day-range-end',
  day_selected:
    'bg-primary text-white hover:bg-primary hover:text-primary-foreground focus:bg-primary focus:text-primary-foreground',
  day_today: 'bg-accent text-accent-foreground',
  day_outside:
    'day-outside text-muted-foreground aria-selected:bg-accent/50 aria-selected:text-muted-foreground',
  day_disabled: 'text-muted-foreground opacity-50',
  day_range_middle: 'aria-selected:bg-accent aria-selected:text-accent-foreground',
  day_hidden: 'invisible',
};

export const CALENDAR_BRAND_TEAL: Partial<ClassNames> = {
  months: 'w-[304px] space-y-3',
  month: 'w-[304px]',
  caption: 'relative mb-3 flex h-10 items-center justify-center',
  caption_label: 'w-40 text-center text-[#00B5AD] font-bold',
  nav: 'flex items-center',
  nav_button:
    'h-8 w-8 rounded-full border border-[#00B5AD] text-[#00B5AD] flex shrink-0 items-center justify-center hover:bg-[#00B5AD] hover:text-white transition-colors',
  nav_button_previous: 'absolute left-1 top-1/2 -translate-y-1/2',
  nav_button_next: 'absolute right-1 top-1/2 -translate-y-1/2',
  head_row: 'grid grid-cols-7 gap-x-1',
  head_cell: 'place-self-center text-[10px] uppercase font-medium text-[#1A2E35]',
  row: 'grid grid-cols-7 gap-x-1 gap-y-2',
  day: 'mx-0 h-10 w-10 rounded-md flex items-center justify-center text-gray-900 hover:bg-teal-50',
  day_outside: 'text-gray-900 day-outside aria-selected:bg-transparent',
  day_disabled: 'text-gray-400 opacity-60',
  day_selected:
    'bg-[#00B5AD] text-white font-bold hover:bg-[#00B5AD] hover:text-white focus:bg-[#00B5AD] focus:text-white',
};

export function mergeCalendarClassNames(
  ...maps: Array<Partial<ClassNames> | undefined>
): Partial<ClassNames> {
  return Object.assign({}, ...maps);
}
